import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
// import CallToActionTwo from '../container/CallToAction/CallToActionTwo';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
// import TopicOne from '../container/topic/TopicOne';
// import EmptyOne from '../components/Empty/EmptyOne.jsx';
import EmptyTwo from "../container/Empty/EmptyTwo.js";

const Topic = () => {
  return (
    <React.Fragment>
      <SEO title="Topic Areas | ICSI 2023" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Topic Areas"
        content="For Authors"
        contentTwo="Topic Areas"
        linkage="/"

      />

      <EmptyTwo>
        <div className="entry-content">
          <table>
            <tbody>
              <tr>
                <th width="140">Theories</th>
                <th width="140">Algorithms</th>
                <th width="140">Realizations</th>
                <th width="140">Emerging Areas</th>
                <th width="140">Applications</th>
              </tr>
              <tr>
                <td>
                  <ul>
                    <li>Swarm intelligence optimization theories</li>
                    <li>Swarm computing</li>
                    <li>Swarm emulation</li>
                    <li>Natural computing</li>
                    <li>Evolutionary computing</li>
                    <li>Social evolution</li>
                    <li>Cooperative theories</li>
                    <li>Optimization theories</li>
                    <li>Immune system theory</li>
                    <li>Multi-agent system theories</li>
                    <li>Reinforcement learning</li>
                    <li>Swarm Robotics</li>
                    <li>Evolutionary learning</li>
                    <li>Collective intelligence</li>
                    <li>Social intelligence</li>
                  </ul>
                </td>

                <td>
                  <ul>
                    <li>PSO algorithms</li>
                    <li>ACO algorithms</li>
                    <li>Fireworks algorithms</li>
                    <li>Fish school search</li>
                    <li>Bees algorithms</li>
                    <li>ABC algorithms</li>
                    <li>BSO algorithms</li>
                    <li>Cultural algorithms</li>
                    <li>Social computing</li>
                    <li>Genetic algorithms</li>
                    <li>Differential evolution</li>
                    <li>Memetic algorithms</li>
                    <li>Bioinspired algorithm</li>
                    <li>Cuckoo / Firefly / Bat Algorithms</li>
                    <li>Biogeography-based Optimization</li>
                    <li>Evolutionary strategy</li>
                    <li>Evolutionary Learning systems</li>
                    <li>GPU Computing</li>
                    <li>Other swarm-based algorithms</li>
                  </ul>
                </td>

                <td>
                  <ul>
                    <li>Swarm models</li>
                    <li>Swarm cooperaton</li>
                    <li>Multi-agent systems</li>
                    <li>AIS system</li>
                    <li>Evolv. intelligent agents</li>
                    <li>Analytic models of emergent behaviors</li>
                    <li>Evolving fuzzy system</li>
                    <li>Evolving neural nets</li>
                    <li>Artificial life</li>
                    <li>Bio-inspired computing models</li>
                    <li>Socio-inspired computing models</li>
                    <li>Routing and scheduling</li>
                    <li>MOO, Many-OO</li>
                    <li>Constrained OP</li>
                    <li>Dynamic OP</li>
                    <li>Combinatorial OP</li>
                    <li>GPU Parallelization</li>
                    <li>Other swaram-based systems</li>
                  </ul>
                </td>

                <td>
                  <ul>
                    <li>Molecular computing</li>
                    <li>DNA computing</li>
                    <li>Quantum computing</li>
                    <li>Granularity computing</li>
                    <li>Deep computing</li>
                    <li>Pervasive computing</li>
                    <li>Cloud computing</li>
                    <li>Metaverse</li>
                  </ul>
                </td>

                <td>
                  <ul>
                    <li>UAV control</li>
                    <li>Swarm cooperation</li>
                    <li>Automatic control</li>
                    <li>Intelligent transport</li>
                    <li>Information security</li>
                    <li>Robotic manipulator</li>
                    <li>Cognitive robots</li>
                    <li>Virtual swarms</li>
                    <li>AR+VR techniques</li>
                    <li>Bioinformatics</li>
                    <li>Telecommunications</li>
                    <li>Underwater vehicles</li>
                    <li>Automatic driving</li>
                    <li>Games</li>
                    <li>Internet+ techniques</li>
                    <li>Machine learning</li>
                    <li>Data mining</li>
                    <li>Other SI applications</li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </EmptyTwo>
      {/* <HomeAbout /> */}
      {/* <EmptyOne>
                <p>
                    yifan
                </p>
            <EmptyOne title="Topic Areas | ICSI 2022"/> */}
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Topic;
